<template>
  <div class="main">
    <div v-if="printList && printList.length > 0" class="content">
      <el-table :data="printList" class="table-content" :height="tableHeight" ref="paramRef"
        :row-style="{ height: rowHeight + 'px' }" :cell-style="{ padding: 6.3 + 'px' }">
        <el-table-column align="center" label="序号" type="index" width="50px" />
        <el-table-column align="center" label="院校名称" prop="institutionName" :show-overflow-tooltip="false"
          width="250" />
        <el-table-column align="center" label="考点名称" prop="title" :show-overflow-tooltip="false" width="150" />
        <el-table-column align="center" label="报名时间" prop="applyStartTime ,applyEndTime" :show-overflow-tooltip="false"
          width="250">
          <template slot-scope="scope">
            {{ scope.row.applyStartTime | parseTime }} ~<br />{{ scope.row.applyEndTime | parseTime }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="打印准考证时间" prop="applyStartTime ,applyEndTime"
          :show-overflow-tooltip="false" width="250">
          <template slot-scope="scope" v-if="scope.row.printTicketStartTime && scope.row.printTicketEndTime">
            {{ scope.row.printTicketStartTime | parseTime }} ~<br />{{ scope.row.printTicketEndTime | parseTime }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="考试时间" prop="startTime ,endTime" :show-overflow-tooltip="false"
          width="200">
          <template slot-scope="scope">
            {{ scope.row.startTime | parseTime }} ~<br />{{ scope.row.endTime | parseTime }}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="examStatus.msg" label="报考状态" width="150" />
        <el-table-column align="center" prop="status" label="操作" fixed="right" width="120">
          <template slot-scope="{ row }">
            <el-button v-if="row.examStatus.code === 6 &&
              row.printTicketStartTime &&
              row.printTicketEndTime &&
              rangeTime([row.printTicketStartTime, row.printTicketEndTime])
            " type="primary" size="small" icon="el-icon-search" class="button-style" @click="handleView(row)">查看</el-button>

            <!-- <el-button type="primary" size="small" icon="el-icon-search" class="button-style"
              @click="handleView(row)">查看</el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-else>
      <el-empty class="enpty" description="暂无考试信息"></el-empty>
    </div>
    <AdmissionCertificate :userS="userS" :row="row" :adVisible.sync="admissionVisible" :admissionObj="admissionTemp"
      :baseInfoObj="baseInfoObj" />
  </div>
</template>
<script>
import { parseTime } from '@/utils/time'
import { mapState } from 'vuex'
import AdmissionCertificate from './AdmissionCertificate.vue'
import { getPrintList } from '../api/printNTS'
import { getUserDetail } from '@/api/common.js'
import moment from 'moment/moment'
export default {
  filters: {},
  components: {
    AdmissionCertificate
  },
  data() {
    return {
      userS: {},
      row: {},
      rowHeight: 0, //表格行高
      tableHeight: window.innerHeight - 248,
      printList: [],
      listQuery: {
        pageNum: 1,
        pageSize: 10,
        condition: {
          institutionId: '',
          status: '',
          title: ''
        }
      },
      admissionVisible: false,
      baseInfoObj: {} //获取考生个人信息
    }
  },
  computed: {
    ...mapState({
      // printList: (state) => state.registrationQuery.queryList, //此处进行过滤状态为“打印准考证”的列表
      admissionTemp: state => state.printNTS.templateList.find(item => item.type === 'AdmissionTicket')
    }),
    rangeTime() {
      return time => moment().isBetween(...time)
    }
  },
  created() {
    this.getPrintList()
  },
  mounted() {


    const {institutionId,userIdCardBack,userIdCardFront,avatar} = JSON.parse(localStorage.getItem('fstat'))
    if(!(institutionId&&userIdCardBack&&userIdCardFront&&avatar)){
      this.$message.warning('请在“个人中心”完善用户信息')
      this.$router.push({ path: '/personalCenter' })
      return
    }
  },
  methods: {
    initRowHeight() {
      let tableHeight =
        Math.round(this.$refs['paramRef'].$el.offsetHeight) -
        Math.round(this.$refs['paramRef'].$el.childNodes[1].offsetHeight)
      // 返回小于等于最终结果的最大整数
      this.rowHeight = Math.floor(tableHeight / 10)
    },
    handleView(row) {
      this.row = row
      this.getUserDetail(row.id)
      console.log(row.examId)
    },
    //获取考生个人信息
    getUserDetail(id) {
      console.log(id)
      getUserDetail(id).then(res => {
        console.log(res);
        this.userS = res
        //获取考生个人信息
        if (res) {
          this.baseInfoObj = {
            ...res,
            ...res.examModel,
            ...res.examUserBaseModel
          }
        }
      })
    },
    getPrintList() {
      getPrintList({
        pageNum: 1,
        pageSize: 100,
        condition: {
          institutionId: '',
          userId: JSON.parse(localStorage.getItem('userInfo')).userId
        }
      }).then(res => {
        this.printList = res.list.map(item => {
          return {
            ...item.examModel,
            examStatus: item.status,
            examId: item.examId,
            id: item.id,
            examineDesc: item.examineDesc
          }
        })
      })
    }
  },
  filters: {
    parseTime(val) {
      return parseTime(val, '{y}-{m}-{d} {h}:{i}') || '--'
    }
  }
}
</script>
<style lang="scss" scoped>
@media screen and (min-width: 320px) and (max-width: 768px) {
  @import '../styles/index.mobile';
}

@media screen and (min-width: 769px) {
  @import '../styles/index.pc';
}
</style>
